import { render, staticRenderFns } from "./ImovelRural.vue?vue&type=template&id=13ba8096&lang=pug"
import script from "./ImovelRural.vue?vue&type=script&lang=js"
export * from "./ImovelRural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports